"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc1155EditContractsValidationSchemaCreator = exports.erc1155CreateContractsValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const types_1 = require("../../../../../types");
exports.erc1155CreateContractsValidationSchema = (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
});
const erc1155EditContractsValidationSchemaCreator = (service) => (0, yup_1.object)().shape({
    title: yup_rules_1.titleValidationSchema,
    description: yup_rules_1.draftValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
    imageUrl: yup_rules_1.urlValidationSchema,
    ...(service === types_1.ServiceType.ADMIN && { symbol: yup_rules_1.symbolValidationSchema }),
    ...(service === types_1.ServiceType.OFFICE && { merchantId: yup_rules_1.dbIdValidationSchema }),
});
exports.erc1155EditContractsValidationSchemaCreator = erc1155EditContractsValidationSchemaCreator;
//# sourceMappingURL=validation.js.map